import React from 'react'
import TextInput from './inputs/TextInput'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import {
  isRequired
} from "../validators"

class LevelLabels extends React.Component {
  render() {
    const { levelname, parentstate, track, base } = this.props
    const { description, label } = parentstate
    return (
      <Grid container style={{marginBottom: 40}}>

        <Grid item xs={12} md={4}>
          <Typography className="h6 mb-12">Level {levelname} Label</Typography>
          <TextInput
            id={`${base}-label-${levelname}`}
            model={track(`${base}.levels[].label`, (lev) => lev && lev.name === levelname)}
            multiline={true}
            rowsMax={6}
            placeholder={`Level ${levelname} label`}
            error={label}
            helperText={`Level ${levelname} label`}
            validators={{
              required: val=> isRequired(val)
            }}
          />

          <Typography className="h6 mb-12">Level {levelname} Description</Typography>
          <TextInput
            id={`${base}-description-${levelname}`}
            model={track(`${base}.levels[].description`, (lev) => lev && lev.name === levelname)}
            multiline={true}
            rowsMax={6}
            placeholder={`Level ${levelname} description`}
            error={description}
            helperText={`Level ${levelname} description`}
            validators={{
              required: val=> isRequired(val)
            }}
          />
        </Grid>

      </Grid>
    )
  }
}

export default LevelLabels



// WEBPACK FOOTER //
// ./src/js/components/LevelLabels.js